<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title15"></a><div class="title-toc">Table of Contents</div>
<div class="toc_entry"><span class="toc_entry_titlePage" href="#/e9781466800496_tp01" id="toctitle12" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<a class="toc_entry_chapter" href="#/e9781466800496_c01" id="toctitle1"><span><strong class="b">THE PARTY</strong></span></a><br/>
<a class="toc_entry_chapter" href="#/e9781466800496_c02" id="toctitle2"><span><strong class="b">A PLACE IN THE COUNTRY</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/e9781466800496_c03" id="toctitle3" title="Link target outside of Sample"><span><strong class="b">VITTORIO</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466800496_c04" id="toctitle4" title="Link target outside of Sample"><span><strong class="b">IN ONE’S OWN HOUSE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466800496_c05" id="toctitle5" title="Link target outside of Sample"><span><strong class="b">VILLA ADRIANA</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466800496_c06" id="toctitle6" title="Link target outside of Sample"><span><strong class="b">CLIFFS OF FALL</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466800496_c07" id="toctitle7" title="Link target outside of Sample"><span><strong class="b">WEEKEND</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466800496_c08" id="toctitle8" title="Link target outside of Sample"><span><strong class="b">HAROLD</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466800496_c09" id="toctitle9" title="Link target outside of Sample"><span><strong class="b">THE PICNIC</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781466800496_c10" id="toctitle10" title="Link target outside of Sample"><span><strong class="b">THE WORST MOMENT OF THE DAY</strong></span></span><br/><br/>
<span class="toc_entry_alsoby" href="#/e9781466800496_als01" id="toctitle11" title="Link target outside of Sample"><span><strong class="b">ALSO BY SHIRLEY HAZZARD</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781466800496_cop01" id="toctitle13" title="Link target outside of Sample"><span>Copyright Page</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466800496_toc01.vue?109e8eb2